<template>
  <div class="container">
    <div class="info">
      <div class="title">{{ Info.localizationTitle }}</div>
      <div class="time" v-if="Info.contentType == '1'">{{ Info.occurrenceTime | getLocalDate }}</div>
      <div class="imgg" v-if="Info.contentType == '1'">
        <img class="iiimg" v-if="Info.image" :src="isHttp(Info.image) ? Info.image : baseUrl + Info.image">
        <img class="iiimg" v-else src="@/assets/img/new_local.jpg">
      </div>
      <div class="content  ql-editor" v-html="Info.localizationContent"></div>
    </div>
  </div>
</template>

<script>
import systemApi from '@/api/system'
export default {
  components: {
  },
  data() {
    return {
      baseUrl: window.baseURL,
      Info: {},
    }
  },
  async mounted() {
    window.scrollTo(0, 0);
    if (this.$route.query.id) {
      //内容类型(0隐私协议1平台公告2帮助中心)
      var res = await systemApi.getContentInfo({ contentLocalizationId: this.$route.query.id })
      this.Info = res.data
    }
  },
  methods: {
    isHttp(url) {
      return /^https?:\/\//.test(url)
    },
  }
}
</script>

<style lang="less" scoped>
.container {
  min-height: 100vh;
  padding-top: 110px;
  padding-bottom: 80px;
  margin-bottom: -60px;
  width: 100%;
  background: var(--background_color);

  .info {
    margin: 0 auto;
    max-width: 1280px;

    .title {
      font-weight: bold;
      font-size: 21px;
      color: var(--text_color);
      line-height: 25px;
      text-align: center;
    }

    .time {
      margin-top: 10px;
      font-size: 15px;
      color: var(--ntext_color);
      text-align: center;
    }

    .imgg {
      margin-top: 50px;
      text-align: center;

      .iiimg {
        max-width: 780px;
      }
    }

    .content {
      margin-top: 20px;
      font-size: 15px;
      color: var(--text_color);
      line-height: 25px;
      white-space: pre-wrap;
    }
  }

}
</style>
